import { useRef, useState, useEffect } from "react";
import type { ReactNode } from "react";
import Stack from "@mui/joy/Stack";
import { SxProps } from "@mui/system";

interface Props {
  children: ReactNode;
  sx?: SxProps;
}

// code from Elstar
const StickyFooter = ({ children, sx }: Props) => {
  const [isSticky, setIsSticky] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cachedRef = ref.current;
    const observer = new IntersectionObserver(([e]) => setIsSticky(e.intersectionRatio < 1), {
      threshold: [1],
    });

    observer.observe(cachedRef as Element);

    return function () {
      observer.unobserve(cachedRef as Element);
    };
  }, []);

  return (
    <Stack
      direction={"row"}
      ref={ref}
      justifyContent={"flex-start"}
      gap={2}
      sx={[
        {
          bgcolor: "white",
          py: 2,
          position: "sticky",
          bottom: 0,
          zIndex: 20,
          borderTop: "1px solid",
          borderColor: "neutral.300",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  );
};

export default StickyFooter;
